import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { PricingSelector } from './PricingSelector';
export function OfferSection() {
  return <section id="oferta" className="py-10 sm:py-16 lg:py-24 bg-navy-900 relative overflow-hidden" data-id="element-172">
      <div className="absolute inset-0 bg-radial-glow opacity-50 pointer-events-none" data-id="element-173" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-174">
        <div className="text-center mb-6 sm:mb-10" data-id="element-175">
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-display text-offwhite uppercase mb-2 sm:mb-4" data-id="element-176">
            OFERTA DE <span className="text-gold-500" data-id="element-177">LANZAMIENTO</span>
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-text-secondary font-medium" data-id="element-178">
            Y no vuelve a bajar.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-800 border-2 border-gold-500/40 rounded-3xl p-4 sm:p-6 md:p-10 shadow-[0_0_50px_rgba(220,38,38,0.15)] relative" data-id="element-179">
          {/* Top Bar */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6 pb-6 sm:pb-8 border-b border-navy-700" data-id="element-180">
            <Countdown className="scale-100 sm:scale-110 md:scale-125 origin-center sm:origin-left" data-id="element-181" />

            <div className="w-full sm:w-1/2" data-id="element-182">
              <div className="flex justify-between text-xs sm:text-sm font-bold text-offwhite mb-1.5 sm:mb-2" data-id="element-183">
                <span data-id="element-184">Cupos restantes:</span>
                <span className="text-gold-400" data-id="element-185">68% TOMADOS</span>
              </div>
              <div className="h-2 sm:h-3 bg-navy-900 rounded-full overflow-hidden border border-navy-700" data-id="element-186">
                <motion.div initial={{
                width: 0
              }} whileInView={{
                width: '68%'
              }} viewport={{
                once: true
              }} transition={{
                duration: 1.5,
                ease: 'easeOut'
              }} className="h-full bg-gold-500" data-id="element-187" />
              </div>
            </div>
          </div>

          {/* Pricing Content */}
          <div className="pt-6 sm:pt-8 text-center" data-id="element-188">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-offwhite mb-1 sm:mb-2" data-id="element-189">
              Elegí tu Dominio Total en la Mesa
            </h3>
            <p className="text-xs sm:text-sm md:text-base text-text-secondary mb-6 sm:mb-8" data-id="element-190">
              Ambas opciones incluyen los 3 bonos estratégicos completos.
            </p>

            <PricingSelector data-id="element-191" />
          </div>
        </motion.div>
      </div>
    </section>;
}